export default __webpack_public_path__ + "static/media/AmbientSciFi.cf7720a8.mp3";